import React from "react";
import { CheckIcon } from "@heroicons/react/solid";

import EasyTrans from "../bundel/EasyTrans";
import HelpIcon from "./HelpIcon";
import { iconFor } from "../bundel/WorkGridCard";

/**
 * Selectable work-type card (radio under the hood). Shows the type icon and a
 * translated label; the selected card is highlighted with a check badge.
 */
const WorktypButton = (props) => {
  const Icon = iconFor(props.type);
  return (
    <div className="relative">
      <input
        type="radio"
        name="Worktype"
        id={props.type}
        className="peer sr-only"
        value={props.type}
        onClick={() => {
          props.onSetType(props.type);
          props.setTypeError(false);
        }}
      />
      <label
        htmlFor={props.type}
        className={`flex h-full cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border bg-white p-4 text-center shadow-sm transition hover:border-fairblue-500 hover:shadow peer-checked:border-fairblue-500 peer-checked:bg-fairblue-50 peer-checked:ring-1 peer-checked:ring-fairblue-500 ${
          props.typeError ? "border-red-400" : "border-gray-200"
        }`}
      >
        <Icon className="h-7 w-7 text-fairblue-500" aria-hidden="true" />
        <span className="text-sm font-medium text-gray-800">
          <EasyTrans>{`RegisterWork.Element.WorkType.${props.type}`}</EasyTrans>
        </span>
      </label>

      {/* selected check (sibling of the radio so peer-checked applies) */}
      <span className="absolute left-2 top-2 hidden h-5 w-5 items-center justify-center rounded-full bg-fairblue-500 text-white peer-checked:flex">
        <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" />
      </span>

      {/* help (outside the label so it doesn't toggle the radio) */}
      <div className="absolute right-1 top-1">
        <HelpIcon Title={props.type} Message={props.helpMessage} />
      </div>
    </div>
  );
};

export default WorktypButton;
